module.exports = __webpack_public_path__ + "img/japan1.58ba8dc6.jpg";